import { MFCentralStatusResponse } from "../types";
import { api } from "./axios";

export const generateMfCentralOtp = async (
  investmentAccountId: string,
  contactInfo?: string
) => {
  return api.post(`mfcentral/send-otp/`, {
    investment_account_guid: investmentAccountId,
    contact_info: contactInfo,
  });
};

export const verifyMfCentralOtp = async (
  investmentAccountId: string,
  otp: string
) => {
  return api.post(`mfcentral/verify-otp/`, {
    investment_account_guid: investmentAccountId,
    otp,
  });
};

export const fetchMfCentralStatus = async (
  investmentAccountId: string
): Promise<MFCentralStatusResponse> => {
  return api.get(`mfcentral/webhook_status/`, {
    params: {
      investment_account_guid: investmentAccountId,
    },
  });
};

export function uploadCasApi(data: FormData) {
  return api.post(
    "cas-imports/",
    {
      cas_file: data.get("file"),
      password: data.get("password"),
      investment_account_guid: data.get("investment_account_guid"),
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

export function fetchCasUploadStatus(investmentAccountId: string): Promise<{
  id: number;
  investment_account: number;
  password: string;
  status: "CREATED" | "FILE_RECEIVED" | "SUCCESS" | "FAILED" | "CANCELLED";
  remarks: string;
  created_at: string;
  updated_at: string;
}> {
  return api.get("cas-imports/upload-status/", {
    params: { investment_account_guid: investmentAccountId },
  });
}

export function mfCentralV2RequestApi(payload: {
  investmentAccountId: string;
  contactInfo: string;
}): Promise<{ redirect_url: string }> {
  return api.post("mfcentral-new/create-request/", {
    investment_account_guid: payload.investmentAccountId,
    contact_info: payload.contactInfo,
  });
}

export function mfCentralV2UploadQrApi(payload: {
  investmentAccountId: string;
  qr_code: string;
}) {
  return api.post("mfcentral-new/upload-qr/", {
    investment_account_guid: payload.investmentAccountId,
    qr_code: payload.qr_code,
  });
}
